import { FC, ReactNode } from 'react';
import { ILocationDetails } from '../../model';

import styles from './LocationDetails.module.scss';

const EMPTY_VALUE = '—';

interface Props {
  location: ILocationDetails;
}

const InfoRow: FC<{ label: string; value: ReactNode }> = ({ label, value }) => (
  <div className={styles.infoRow}>
    <span className={styles.infoLabel}>{label}</span>
    <span>{value ?? EMPTY_VALUE}</span>
  </div>
);

const LocationDetailsGeneral: FC<Props> = ({ location }) => (
  <div className={styles.generalInfo}>
    <InfoRow label='Id' value={location.id} />
    <InfoRow label='Name' value={location.name} />
    <InfoRow label='Address' value={location.address || null} />
    <InfoRow label='Capacity' value={location.capacity} />
    <InfoRow label='Grace Period' value={`${location.gracePeriodMin} min`} />
  </div>
);

export default LocationDetailsGeneral;
